// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tasks_wrapper__3RB-s","list":"Tasks_list__2yfBd","container":"Tasks_container__3z6Fe","header":"Tasks_header__3M2qd"};